// src/components/layout/PageBreadcrumbs.js

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumbs, Typography, Box, alpha } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';
import { useTheme } from '@mui/material/styles';

const getPageTitle = (pathname) => {
  const routes = {
    '/home': 'ダッシュボード',
    '/plans': '採用計画アシスト',
    '/media': '募集媒体選定',
    '/job-posts': '求人票の自動作成',
    '/interview-support': '面接サポート',
    '/settings': '設定',
    '/admin': '管理コンソール',
  };
  return routes[pathname] || '';
};

function PageBreadcrumbs() {
  const location = useLocation();
  const theme = useTheme();
  const title = getPageTitle(location.pathname);
  const textColor = theme.palette.primary.main;

  if (!title || location.pathname === '/home') {
    return null;
  }

  return (
    <Box sx={{ mb: 2, display: { xs: 'none', md: 'block' } }}>
      <Breadcrumbs
        separator={<NavigateNextIcon sx={{ fontSize: 18 }} />}
        sx={{
          '& .MuiBreadcrumbs-separator': {
            color: alpha(textColor, 0.4),
          },
        }}
      >
        <Link
          to="/home"
          style={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            color: alpha(textColor, 0.6),
            fontSize: '0.875rem',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.color = textColor)}
          onMouseLeave={(e) => (e.currentTarget.style.color = alpha(textColor, 0.6))}
        >
          <HomeIcon sx={{ fontSize: 18, mr: 0.5 }} />
          ホーム
        </Link>
        <Typography
          sx={{
            fontSize: '0.875rem',
            fontWeight: 600,
            color: textColor,
          }}
        >
          {title}
        </Typography>
      </Breadcrumbs>
    </Box>
  );
}

export default PageBreadcrumbs;
